import NextImage from 'next/image';
import { Box, styled, Theme, Typography } from '@mui/material';
import { BoxProps, MUIStyledCommonProps } from '@mui/system';
import { StyledComponent } from '@emotion/styled';
import { RoundedCornersType } from './BannerTitle.types';

export const Title = styled(Typography)`
  position: absolute;
  width: calc(100% - 2.5rem);
  left: 1.25rem;
  bottom: 1.25rem;
`;
type T = {
  roundedCorners: RoundedCornersType;
  theme: Theme;
  cornerOfInterest?: keyof RoundedCornersType;
};
function getCornerRadius({
  roundedCorners,
  theme,
  cornerOfInterest,
}: T): string {
  return roundedCorners[cornerOfInterest]
    ? `${theme.shape.borderRadius}px`
    : 'unset';
}

export const ImageContainer: StyledComponent<
  BoxProps,
  MUIStyledCommonProps<Theme>,
  any
> = styled(Box)`
  position: relative;
  overflow: hidden;
  grid-area: image;
  width: 100vw;
  border-top-left-radius: ${({ theme, roundedCorners }: T) =>
    getCornerRadius({ theme, roundedCorners, cornerOfInterest: 'topLeft' })};
  border-bottom-left-radius: ${({ theme, roundedCorners }: T) =>
    getCornerRadius({ theme, roundedCorners, cornerOfInterest: 'bottomLeft' })};
  border-top-right-radius: ${({ theme, roundedCorners }: T) =>
    getCornerRadius({ theme, roundedCorners, cornerOfInterest: 'topRight' })};
  border-bottom-right-radius: ${({ theme, roundedCorners }: T) =>
    getCornerRadius({
      theme,
      roundedCorners,
      cornerOfInterest: 'bottomRight',
    })};
  height: 260px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.1875) 11.46%,
    rgba(0, 0, 0, 0.03) 44.79%,
    rgba(0, 0, 0, 0.6) 85.94%
  );
  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 400px;
    width: 100%;
  }
`;

export const Image = styled(NextImage)`
  z-index: -1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const IconContainer = styled(Box)`
  position: absolute;
  top: ${({ theme }) => theme.spacing(4)};
  right: ${({ theme }) => theme.spacing(4)};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    /* mask-size: 32px; */
    /* height: 32px; */
    /* width: 32px; */
  }
`;
